import React, {useEffect, useState} from "react";
import axios from "axios";
import "./AdminLayout.css";

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    try {
      const {data} = await axios.get("/api/contact");
      setContacts(data);
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm("Delete this contact?")) return;
    await axios.delete(`/api/contact/${id}`);
    setContacts((prev) => prev.filter((c) => c._id !== id));
  }

  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Contact Requests</h1>
          <p className="admin-page-sub">{contacts.length} total</p>
        </div>
        <button className="btn-secondary" onClick={load}>
          ↻ Refresh
        </button>
      </div>

      <div style={{padding: "16px 28px 28px"}}>
        <div className="admin-card">
          {loading ? (
            <div className="admin-loading">Loading…</div>
          ) : contacts.length === 0 ? (
            <div className="empty-state">
              <span>📬</span>
              <p>No contact requests yet.</p>
            </div>
          ) : (
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>City</th>
                    <th>Message</th>
                    <th>Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {contacts.map((c) => (
                    <tr key={c._id}>
                      <td>
                        <strong>{c.name}</strong>
                      </td>
                      <td>
                        <a
                          href={`mailto:${c.email}`}
                          style={{color: "#f59e0b", textDecoration: "none"}}
                        >
                          {c.email}
                        </a>
                      </td>
                      <td>
                        <a
                          href={`https://wa.me/91${c.phone}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{color: "#25d366", textDecoration: "none"}}
                        >
                          📱 {c.phone}
                        </a>
                      </td>
                      <td>{c.city}</td>
                      <td
                        style={{fontSize: 13, color: "#6b7280", maxWidth: 200}}
                      >
                        {c.message || "—"}
                      </td>
                      <td
                        style={{
                          fontSize: 12,
                          color: "#9ca3af",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {new Date(c.createdAt).toLocaleDateString("en-IN")}
                      </td>
                      <td>
                        <button
                          className="btn-danger"
                          onClick={() => handleDelete(c._id)}
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
